import { useSelector } from 'hooks/utils';
import { selectEntryStatus } from 'store/data/entries';

export function useEntryStatus(initial?: boolean) {
	return useSelector(state => selectEntryStatus(state.data.entries, initial));
}
